module.exports = __webpack_public_path__ + "img/22_fineStaff_mfx.7b656fc0.png";